<template>
  <el-row :gutter="24">
    <el-col :span="24">
      <p><b>Основание для добавления автомобиля</b></p>
      <el-radio-group v-model="reasonForAdd">
        <el-radio :label="1">Собственный транспорт</el-radio>
        <el-radio :label="2">Транспорт контрагента</el-radio>
      </el-radio-group>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'SetReason',
  props: {
    reason: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    reasonForAdd: {
      get() {
        return this.reason
      },
      set(val) {
        this.$emit('changed', val)
      },
    },
  },
}
</script>

<style scoped lang="sass">
.list-none
    padding: 0
    li
        list-style-type: none
</style>
